import "./mobile-design.css";
import "./mobile-motion.css";
import { useMobilePlatform } from "./useMobilePlatform";
import { PushEnablePrompt } from "../notifications/PushEnablePrompt";
import { RoleSession } from "./RoleSession";
import { RoleGate } from "./RoleGate";
import { WorkspaceSections } from "./WorkspaceSections";
import { useNavigationTrail } from "../misc/useReturnToPrevious";
import { useRevealMotion } from "../root/useRevealMotion";
import { useLocation } from "react-router";
import { CreationProvider } from "../misc/CreationProvider";
import { Error } from "@/components/admin/error";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { DataImportProvider } from "../dataImport/DataImportProvider";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { MobileNavigation } from "./MobileNavigation";
import { PullToRefresh } from "./PullToRefresh";
import { useApplyFontPreference } from "../root/useFontPreference";

import { useApplyMotionPreference } from "../root/MotionPreference";

export const MobileLayout = ({ children }: { children: ReactNode }) => {
  useMobilePlatform();
  const location = useLocation();
  useNavigationTrail();
  useConfigurationLoader();
  useApplyFontPreference();
  useApplyMotionPreference();
  useRevealMotion();
  return (
    <DataImportProvider>
      <CreationProvider>
        <RoleSession />
        <PushEnablePrompt />
        <WorkspaceSections mobile />
        <PullToRefresh />
        <ErrorBoundary FallbackComponent={Error}>
          <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
            <div
              key={location.pathname}
              className={`rovero-page ${/\/(contacts|companies|deals|analytics|work-projects|my-tasks|tasks)(\/|$)/.test(location.pathname) ? "has-workspace-sections" : ""}`}
            >
              <RoleGate>{children}</RoleGate>
            </div>
          </Suspense>
        </ErrorBoundary>
        <MobileNavigation />
        <Notification
          mobileOffset={{
            bottom:
              "calc(var(--mobile-navigation-height) + env(safe-area-inset-bottom) + 1rem)",
          }}
        />
      </CreationProvider>
    </DataImportProvider>
  );
};
